<template>
  <el-dialog
    :title="
      isEditDialog
        ? $t('dialog.titlePackageModify')
        : $t('dialog.titlePackageAdd')
    "
    :visible="isShow"
    :close-on-click-modal="false"
    width="800px"
    @close="onClose"
  >
    <!-- START FORM -->
    <div class="das-form-container">
      <!-- <div class="das-form-title-container">
        <div class="das-form-title">
          <span class="main-title">Thông tin chung</span>
        </div>
      </div> -->
      <validation-observer ref="formValidator">
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.generalInformation') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">{{ $t('field.packageCode') }}</div>
                <validation-provider
                  rules="required|max:20|no_special"
                  :name="$t('field.packageCode')"
                >
                  <input
                    v-model="formPackage.code"
                    :disabled="isEditDialog"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.saleStartDate') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.saleStartDate')"
                >
                  <SingleCalendar
                    v-model="formPackage.start_date"
                    class="use-icon"
                    :date-data="formPackage.start_date"
                    @input="onChangeStartDate"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.saleEndDate') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.saleEndDate')"
                >
                  <SingleCalendar
                    v-model="formPackage.end_date"
                    class="use-icon"
                    :date-data="formPackage.end_date"
                    @input="onChangeEndDate"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.packageName') }}
                </div>
                <validation-provider
                  rules="required|max:50"
                  :name="$t('field.packageName')"
                >
                  <input v-model="formPackage.name" type="text" />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.packageCategory') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.packageCategory')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'transaction_code', 'description']"
                    :selected-index-field-value="
                      formPackage.package_category_id
                    "
                    :rows="packCategoryOptions"
                    :columns="packCategoryCols"
                    :value="formPackage.package_category_id"
                    :dropdown-width="400"
                    @selectionChanged="onSelectPackCategory"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span v-if="selectedData?.code">
                          {{ selectedData.code }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">{{ $t('field.desc') }}</div>
                <validation-provider rules="max:200" :name="$t('field.desc')">
                  <textarea v-model="formPackage.description" rows="2" />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label" style="margin-right: 5px">
                  {{ $t('field.active') }}
                </div>
                <el-switch
                  v-model="formPackage.active"
                  active-color="#357456"
                  inactive-color="#CAC9C9"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.transactionDetail') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.transactionCodeOfPackage') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.transactionCodeOfPackage')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'description']"
                    :selected-index-field-value="formPackage.transaction_code"
                    :rows="transactionOptions"
                    :columns="transactionOptionsCols"
                    :value="formPackage.transaction_code"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectTransaction"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span
                          v-if="selectedData?.code && selectedData?.description"
                        >
                          {{ selectedData.code }} -
                          {{ selectedData.description }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.subTransactionCode') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.subTransactionCode')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'description']"
                    :selected-index-field-value="
                      formPackage.sub_transaction_code
                    "
                    :rows="subTransactionOptions"
                    :columns="subTransactionOptionsCols"
                    :value="formPackage.sub_transaction_code"
                    :dropdown-width="400"
                    :disabled="!formPackage.transaction_code"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSubTransaction"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span
                          v-if="selectedData?.code && selectedData?.description"
                        >
                          {{ selectedData.code }} -
                          {{ selectedData.description }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.tansactionPage') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.tansactionPage')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'desc']"
                    :selected-index-field-value="formPackage.transaction_page"
                    :rows="transactionPageOptions"
                    :columns="transactionPageOptionsCols"
                    :value="formPackage.transaction_page"
                    :dropdown-width="400"
                    @selectionChanged="onSelectTransPage"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span v-if="selectedData?.code && selectedData?.desc">
                          {{ selectedData.code }} -
                          {{ selectedData.desc }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">{{ $t('field.currency') }}</div>
                <validation-provider
                  rules="required"
                  :name="$t('field.currency')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'currency_unit']"
                    :selected-index-field-value="formPackage.currency_id"
                    :rows="currencyOptions"
                    :columns="currencyOptionsCols"
                    :value="formPackage.currency_id"
                    :dropdown-width="400"
                    @selectionChanged="onSelectCurr"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span
                          v-if="
                            selectedData?.code && selectedData?.currency_unit
                          "
                        >
                          {{ selectedData.code }} -
                          {{ selectedData.currency_unit }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4 flex align-end">
              <div class="das-form-input checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="tax_fee"
                    v-model="formPackage.tax_fee"
                    type="checkbox"
                  />
                  <label for="tax_fee">{{ $t('field.includeTaxFee') }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.attribute') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.frequenceOfUsingService') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.frequenceOfUsingService')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'transaction_code', 'description']"
                    :selected-index-field-value="
                      formPackage.package_category_id
                    "
                    :rows="packCategoryOptions"
                    :columns="packCategoryCols"
                    :value="formPackage.package_category_id"
                    :dropdown-width="400"
                    :disabled="true"
                    @selectionChanged="onSelectPackCategory"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span v-if="selectedData?.code">
                          {{ selectedData.code }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.billingRule') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.billingRule')"
                >
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'transaction_code', 'description']"
                    :selected-index-field-value="
                      formPackage.package_category_id
                    "
                    :rows="packCategoryOptions"
                    :columns="packCategoryCols"
                    :value="formPackage.package_category_id"
                    :dropdown-width="400"
                    :disabled="true"
                    @selectionChanged="onSelectPackCategory"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span v-if="selectedData?.code">
                          {{ selectedData.code }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-4 flex align-end">
              <div class="das-form-input checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="sold_individually"
                    v-model="formPackage.sold_individually"
                    type="checkbox"
                  />
                  <label for="sold_individually">{{
                    $t('field.enableSaleIndividually')
                  }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.packagePriceInPriceCode') }}
                </div>
                <div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.packagePriceInPriceCode')"
                  >
                    <div class="checks-wrap">
                      <input
                        id="nonIndividual"
                        v-model="formPackage.is_included_price_code"
                        :value="false"
                        type="radio"
                      />
                      <label for="nonIndividual">{{
                        $t('views.configuration.includeInRoomRate')
                      }}</label>
                    </div>
                    <div class="checks-wrap">
                      <input
                        id="individual"
                        v-model="formPackage.is_included_price_code"
                        type="radio"
                        :value="true"
                      />
                      <label for="individual">{{
                        $t('views.configuration.addToPriceCode')
                      }}</label>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.configurationDisplay') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.displayWhenSaleInPriceCode') }}
                </div>
                <div>
                  <validation-provider
                    :name="$t('field.displayWhenSaleInPriceCode')"
                    rules=""
                  >
                    <div class="checks-wrap">
                      <input
                        id="not_display_in_price"
                        v-model="formPackage.display_in_price"
                        :value="1"
                        :disabled="!formPackage.is_included_price_code"
                        type="radio"
                      />
                      <label for="not_display_in_price">
                        {{ $t('views.configuration.distinctFlow') }}
                      </label>
                    </div>
                    <div class="checks-wrap">
                      <input
                        id="display_in_price"
                        v-model="formPackage.display_in_price"
                        :value="2"
                        :disabled="!formPackage.is_included_price_code"
                        type="radio"
                      />
                      <label for="display_in_price">
                        {{ $t('views.configuration.includeInRoomRateFlow') }}
                      </label>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <!-- END FORM -->

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button
          v-if="isEditDialog"
          class="btn primary small"
          @click="updatePackage"
        >
          {{ $t('button.update') }}
        </button>
        <template v-else>
          <!-- <button
            class="btn primary small"
            @click="addPackage({ isAddDetail: true })"
          >
            Tạo mới & thêm chi tiết
          </button> -->
          <button class="btn primary small" @click="addPackage">
            {{ $t('button.create') }}
          </button>
        </template>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import { getTransPageListApi } from '@/api/common/code'
import { getCurrencyListSimpleApi } from '@/api/common/currency'
import { getPackageCategoryApi } from '@/api/Service_Policy/packageCategory'
import { getTransactionListApi } from '@/api/Transaction/transaction'
import { getSubTransactionListApi } from '@/api/Transaction/subTransaction'
import { getPackageApibyId } from '@/api/Service_Policy/package'

export default {
  name: 'PackageFormDialog',
  components: {
    SingleCalendar
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    isEditDialog: {
      type: Boolean,
      required: true
    },
    packageId: Number
  },
  data() {
    return {
      formPackage: {
        code: null,
        name: null,
        description: null,
        package_category_id: null,
        start_date: null,
        end_date: null,
        active: true,
        transaction_code: null,
        sub_transaction_code: null,
        transaction_page: null,
        tax_fee: true,
        currency_id: null,
        sold_individually: true,
        package_price: 1, // hard-code
        frequency_use: 1, // hard-code
        billing_rule: 1, // hard-code
        display_in_price: null,
        is_included_price_code: null
      },

      // SELECT OPTIONS
      transactionOptions: [],
      subTransactionOptions: [],
      transactionPageOptions: [],
      currencyOptions: [],
      packCategoryOptions: [],

      packCategoryCols: [
        {
          headerName: this.$t('grid.column.categoryCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 150,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          flex: 1,
          tooltipField: 'desc'
          // cellClass: "grid-cell-centered",
        }
      ],
      transactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description'
          // cellClass: "grid-cell-centered",
        }
      ],
      subTransactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description'
          // cellClass: "grid-cell-centered",
        }
      ],
      transactionPageOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          flex: 1,
          tooltipField: 'desc'
          // cellClass: "grid-cell-centered",
        }
      ],
      currencyOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'currency_unit',
          flex: 1,
          tooltipField: 'currency_unit'
          // cellClass: "grid-cell-centered",
        }
      ]
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        if (!val) {
          setTimeout(() => {
            this.resetPackageForm()
          }, 500)
        } else {
          if (this.packageId && this.isEditDialog) {
            this.attachFormData(this.packageId)
          }
        }
      }
    },
    'formPackage.is_included_price_code': {
      handler(val) {
        if (!val) {
          this.formPackage.display_in_price = null
        } else {
          if (this.formPackage.display_in_price === null) {
            this.formPackage.display_in_price = 1
          }
        }
      }
    }
    // packageId: {
    //   handler(val) {
    //     if (val) {
    //       this.attachFormData()
    //     }
    //   }
    // }
  },
  beforeMount() {
    this.getTransactionOptions()
    this.getCurrencyOptions()
    this.getTransactionPageOptions()
    this.getPackageCategoryOptions()
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    checkStartEndDateValid() {
      if (
        this.formPackage?.start_date &&
        this.formPackage?.end_date &&
        this.formPackage.start_date > this.formPackage.end_date
      ) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.saleStartDateMustBeforeEnd')
        })
        // setTimeout(() => {
        this.formPackage.end_date = this.$moment(this.formPackage.start_date)
          .add(1, 'd')
          .toDate()
        // .format('YYYY-MM-DD')
        // }, 100)
      }
    },
    onChangeStartDate(date) {
      this.formPackage.start_date = date
      this.checkStartEndDateValid()
    },
    onChangeEndDate(date) {
      this.formPackage.end_date = date
      this.checkStartEndDateValid()
    },
    onSelectPackCategory(data) {
      this.formPackage.package_category_id = data?.id
    },
    onSelectTransaction(data) {
      if (data?.id !== null && data?.id !== undefined) {
        if (this.formPackage.transaction_code !== data.id) {
          this.formPackage.sub_transaction_code = null
        }
      } else {
        this.subTransactionOptions = []
        this.formPackage.sub_transaction_code = null
      }
      this.formPackage.transaction_code = data?.id ?? null
      this.getSubTranSactionOptions(this.formPackage.transaction_code)
    },
    onSelectSubTransaction(data) {
      this.formPackage.sub_transaction_code = data?.id ?? null
    },
    onSelectTransPage(data) {
      this.formPackage.transaction_page = data?.id
    },
    onSelectCurr(data) {
      this.formPackage.currency_id = data?.id
    },

    // SELECT OPTIONS
    async getTransactionOptions() {
      getTransactionListApi({ transactionGroup: 1 }).then(res => {
        this.transactionOptions = res.data
      })
    },
    async getSubTranSactionOptions(selectedId) {
      if (selectedId) {
        getSubTransactionListApi({
          transactionId: selectedId
        }).then(res => {
          this.subTransactionOptions = res.data
        })
      } else {
        this.subTransactionOptions = []
      }
    },
    async getCurrencyOptions() {
      getCurrencyListSimpleApi().then(res => {
        this.currencyOptions = res.data
      })
    },
    async getTransactionPageOptions() {
      getTransPageListApi({ transactionGroup: 1 }).then(res => {
        this.transactionPageOptions = res.data
      })
    },
    async getPackageCategoryOptions() {
      getPackageCategoryApi({ isShowNonActive: false }).then(res => {
        this.packCategoryOptions = res.data
      })
    },
    // END SELECT OPTIONS

    // FORM ACTIONS
    async addPackage({ isAddDetail = false }) {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      this.$emit('addPackage', {
        payload: this.formPackage,
        isAddDetail: isAddDetail
      })
    },
    async updatePackage() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      this.$emit('updatePackage', {
        payload: this.formPackage
      })
    },

    getDefaultPackForm() {
      return {
        code: null,
        name: null,
        description: null,
        package_category_id: null,
        start_date: null,
        end_date: null,
        active: true,
        transaction_code: null,
        sub_transaction_code: null,
        transaction_page: null,
        tax_fee: true,
        currency_id: null,
        sold_individually: true,
        package_price: 1, // hard-code
        frequency_use: 1, // hard-code
        billing_rule: 1, // hard-code
        display_in_price: null,
        is_included_price_code: null
      }
    },
    attachFormData(id) {
      getPackageApibyId(id).then(res => {
        this.formPackage = res.data
        this.getSubTranSactionOptions(this.formPackage?.transaction_code)
      })
    },
    resetPackageForm() {
      this.formPackage = this.getDefaultPackForm()
    }
  }
}
</script>

<style></style>
